const state = {
  spinnerLoading: false,
  barLoading: true,
};

const getters = {
  spinnerLoading(state) {
    return state.spinnerLoading;
  },

  barLoading(state) {
    return state.barLoading;
  },
};

const mutations = {
  setSpinnerLoading(state, status) {
    state.spinnerLoading = status;
  },

  setBarLoading(state, status) {
    state.barLoading = status;
  },
};

const actions = {
  showSpinnerLoading({ commit }) {
    commit("setSpinnerLoading", true);
  },

  hideSpinnerLoading({ commit }) {
    commit("setSpinnerLoading", false);
  },

  showBarLoading({ commit }) {
    commit("setBarLoading", true);
  },

  hideBarLoading({ commit }) {
    commit("setBarLoading", false);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
